// Import model
import { DateRangeField } from '../models/DateRangeField';

// Import base class serializer
import { FieldSerializer } from './FieldSerializer';

// Import dependency types (models and enums used in properties)
import { FieldOptions } from '../models/FieldOptions';

// Import dependency serializers (for complex types)
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DateRangeField - handles JSON serialization and deserialization with type validation
 */
export class DateRangeFieldSerializer {
  /**
   * Deserializes a JSON string into a DateRangeField instance
   */
  static deserialize(json: string): DateRangeField {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DateRangeField instance
   */
  static fromObject(obj: any): DateRangeField {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DateRangeField');
    }


    const instance: DateRangeField = {
      t: obj['_t'] as string,
      description: obj['Description'] as string | undefined,
      apiName: obj['ApiName'] as string | undefined,
      defaultValue: obj['DefaultValue'] as any | undefined,
      isRequired: obj['IsRequired'] as boolean | undefined,
      options: obj['Options'] ? FieldOptionsSerializer.fromObject(obj['Options']) : undefined as any,
      name: obj['Name'] as string,
      label: obj['Label'] as string | undefined,
      enable: obj['Enable'] ? (obj['Enable'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      visible: obj['Visible'] ? (obj['Visible'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      a308De01: obj['_a308de01'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DateRangeField instances
   */
  static deserializeArray(json: string): DateRangeField[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DateRangeField instance to a JSON string
   */
  static serialize(instance: DateRangeField): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DateRangeField instance to a plain object
   */
  static toObject(instance: DateRangeField): any {
    return {
      '_t': instance.t,
      'Description': instance.description,
      'ApiName': instance.apiName,
      'DefaultValue': instance.defaultValue,
      'IsRequired': instance.isRequired,
      'Options': instance.options ? FieldOptionsSerializer.toObject(instance.options) : undefined,
      'Name': instance.name,
      'Label': instance.label,
      'Enable': instance.enable?.map((item: any) =>
        item
      ),
      'Visible': instance.visible?.map((item: any) =>
        item
      ),
      '_a308de01': instance.a308De01,
    };
  }

  /**
   * Serializes an array of DateRangeField instances to a JSON string
   */
  static serializeArray(instances: DateRangeField[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
